import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';
import {transparentize} from 'polished';

export const Wrapper = styled(BoxContainer)`
  box-sizing: border-box;
  padding: 20px;
`;

export const Stage = styled.div`
  margin: 4px 0;
`;

export const Title = styled.span`
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
